export default {
	product: state => state.product,
	payment: state => state.payment
}